export default __webpack_public_path__ + "static/media/landing-layer.6f284bf9.svg";